var render = function render(){var _vm=this,_c=_vm._self._c;return _c('single-article',{attrs:{"article":_vm.article,"breadcrumbs":_vm.breadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }